import { WebComponentUIContext } from '@weave/schema-gen-ts/dist/schemas/payments-platform/justifi-integration/justifi_integration.pb';
import { useJustifiAuthToken } from './use-justifi-auth-token';
import { useJustifiBusinessData } from './use-justifi-business-data';

export function useJustifiPaymentsProvisioning(locationId?: string) {
  const { businessId, isLoading: isLoadingBusiness } = useJustifiBusinessData({ locationId });

  const { authToken, isLoading: isLoadingToken } = useJustifiAuthToken({
    locationId,
    businessId,
    webComponentUiContext: WebComponentUIContext.WEB_COMPONENT_UI_CONTEXT_ONBOARDING,
  });

  return {
    businessId,
    authToken,
    isLoading: isLoadingBusiness || isLoadingToken,
  };
}
